import { Get, MgtTemplateProps, Person, FileList } from '@microsoft/mgt-react'
import { Item } from 'devextreme-react/tab-panel'
import { LoadIndicator, TabPanel } from 'devextreme-react'
import { useScreenSize } from '@/themes/media-query'

function EmailsComponent(props: MgtTemplateProps) {
  const email = props.dataContext
  return (
    <div>
      <div className="email">
        <div className="header">
          <div>
            <Person personQuery={email.sender.emailAddress.address} view={'oneline'} personCardInteraction={'hover'} />
          </div>
        </div>
        <div className="title">
          <a href={email.webLink} target="_blank" rel="noreferrer">
            <h3>{email.subject}</h3>
          </a>
          <span className="date">{new Date(email.receivedDateTime).toLocaleDateString()}</span>
        </div>
        {/* {email.bodyPreview ?? <div className="preview">{email.bodyPreview}</div>}
        {!email.bodyPreview ?? <div className="preview empty-body">...</div>} */}
      </div>
    </div>
  )
}

function LoadingComponent(props: MgtTemplateProps) {
  return <LoadIndicator id="small-indicator" height={20} width={20} />
}
const FromYourAccountCard = () => {
  const currentScreenSize = useScreenSize()
  return (
    <>
      <TabPanel
        deferRendering={true}
        swipeEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall}
        animationEnabled={true}
      >
        <Item title={'Email'}>
          <div id="mgt-email-container" className="mgt-get-email">
            <Get resource="/me/mailFolders/Inbox/messages?$top=6" maxPages={1}>
              <EmailsComponent template="value"></EmailsComponent>
              <LoadingComponent template="loading"></LoadingComponent>
            </Get>
          </div>
        </Item>
        <Item title={'File Personali'}>
          <FileList pageSize={8} />
        </Item>
      </TabPanel>
    </>
  )
}

export default FromYourAccountCard
